import React, {FC} from 'react';

import {MediaQuery} from '@optimaxdev/design-system';
import {useMediaQuery} from 'react-responsive';

import {Price} from 'components/price/price';

import s from '../../upsellsList.scss';

export type SunglassesUpsellContentType = {
    isAdded: boolean;
    price: number;
    specialPrice: number;
};

/**
 * Sunglasses upsell content
 */
export const SunglassesUpsellContent: FC<SunglassesUpsellContentType> = ({
    isAdded,
    price,
    specialPrice,
}) => {
    const isSmallScreen = useMediaQuery(MediaQuery.sm);

    return (
        <>
            Add same frame as Sunglasses and{' '}
            <strong className={s.red}>
                Save <Price>29</Price>!
            </strong>{' '}
            Same Rx. and lenses{!isSmallScreen && <br />} with <strong>FREE</strong> gray tint{' '}
            {isAdded && (
                <span className={s.price}>
                    (+
                    {!specialPrice || specialPrice === price ? (
                        <Price>{price}</Price>
                    ) : (
                        <>
                            <Price>{specialPrice}</Price>
                            <span className={s.old}>
                                <Price>{price}</Price>
                            </span>
                        </>
                    )}
                    )
                </span>
            )}
        </>
    );
};
